import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppContainerOptions,
  AppContainerService,
  AppRightDrawerService,
  RightDrawerContent,
  UserMenuItem,
} from '@mydocma/app-container';
import { AuthService, JwtAuthService } from '@mydocma/auth';
import { ConfigProvider } from '@mydocma/core';
import { Project, ProjectService } from '@mydocma/project';
import { MessageCenterComponent } from 'projects/mydocma/pr/src/lib/common/components/message-center/message-center.component';
import { PrConfig } from 'projects/mydocma/pr/src/lib/configuration/pr.config';
import { SideNavBarButtonsEnum } from 'projects/mydocma/pr/src/lib/services/side-navbar.service';
import package_json from '../../../package.json';

@Component({
  selector: 'mydocma-pr-document-preview-main',
  templateUrl: './document-preview-main.component.html',
  styleUrls: ['./document-preview-main.component.scss'],
})
export class DocumentPreviewMainComponent {
  public version: string = package_json.version as string;
  public projectName!: string;
  private jwtAuthService: JwtAuthService;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public containerOptions: AppContainerOptions,
    private appContainerService: AppContainerService,
    readonly appRightDrawerService: AppRightDrawerService,
    private readonly projectService: ProjectService,
    private readonly authService: AuthService,
  ) {
    this.jwtAuthService = this.authService as any;
  }

  async ngOnInit(): Promise<void> {
    const configProvider = new ConfigProvider<PrConfig>({} as PrConfig);
    const config = await configProvider.loadConfigAsync();

    this.appContainerService.notifyChanges((appContainer: AppContainerOptions) => {
      this.containerOptions = appContainer;
      this.containerOptions.appIcon.name = config.appName;
      this.containerOptions.appIcon.color = config.appIconColor;

      this.containerOptions.header.customerSelection = false;
      this.containerOptions.header.projectSelection = false;
      this.containerOptions.header.userMenuItems.version = this.version;

      this.containerOptions.rightDrawer.contents = [
        new RightDrawerContent({
          id: SideNavBarButtonsEnum.MESSAGES,
          componentType: MessageCenterComponent,
        }),
      ];

      this.containerOptions.sideNavBar.isVisible = false;
      this.containerOptions.sideNavBar.classes = ['pr-side-navbar-on-share-link'];
      this.containerOptions.header.userMenuItems?.items?.forEach((item: UserMenuItem) => {
        if (item.id === 'userSettings') {
          item.hidden = true;
        }
        if (item.id === 'signOut') {
          item.click = () => {
            const fullUrl = window.location.origin + this.router.url;
            this.jwtAuthService.signout(undefined, fullUrl);
          };
        }
      });
    });

    this.projectService.currentProject.subscribe((project: Project) => {
      if (project) {
        this.projectName = project?.name + '  ' + project?.desc;
      }
    });
  }

  toggleMessageCenter(): void {
    this.appRightDrawerService.toggleContent(SideNavBarButtonsEnum.MESSAGES, this.containerOptions);
  }
}
